import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isAllowEdit } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchSupplierDetails } from '@store/supplier/action';

import { fetchSupplierData, onRemoveCertificate } from '@services/supplierService';

import { changeDateFormat, getFileType, getIconByFileType } from '@utils/Util';

const OcsCertificate = ({ onClose, ocsType, onAllRemoved }) => {
	const [ocSlist, setOcsList] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		onFetchOcs();
	}, []);

	const onFetchOcs = async () => {
		try {
			dispatch(openLoader());
			const response = await fetchSupplierData({
				supplierId: id,
				type: 'OCS',
				ocsType
			});
			if (response) {
				setOcsList(response);
				dispatch(closeLoader());
			}
		} catch {
			dispatch(closeLoader());
		}
	};

	const renderFileDummyImage = (type) => {
		let fileType;
		if (type.docUrl) {
			fileType = getFileType(type.docUrl);
		} else {
			fileType = getFileType(type.name);
		}
		if (fileType === 'IMAGE' || fileType === 'NO_FILE')
			return <img width="54px" src={type.docUrl} alt="Upload" />;
		else
			return (
				<img
					width="54px"
					src={getIconByFileType(fileType)}
					onClick={() => {
						if (type.docUrl) {
							window.open(type.docUrl, '_blank').focus();
						}
					}}
					alt="certificate-image"
				/>
			);
	};

	const onRemove = async (cId) => {
		try {
			dispatch(openLoader());
			const response = await onRemoveCertificate(cId);
			if (response) {
				dispatch(fetchSupplierDetails(id));
				let tempData = [...ocSlist];
				tempData = tempData?.filter((item) => item?.id !== cId);
				setOcsList(tempData);
				if (tempData?.length === 0) {
					onAllRemoved();
					onClose();
				}
				dispatch(closeLoader());
			}
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer className="osc-certificate-modal">
			<div className="common-popup osc-certificate-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">{ocsType} Certificate</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="ocs-pdfs">
						{ocSlist?.map((item) => (
							<div className="ocs-pdf-single d-flex align-items-start" key={item?.id}>
								<div className="img">{renderFileDummyImage(item?.documentResponse)}</div>
								<p className="regular-12 gray_dark_02">
									Upload: {changeDateFormat(item?.createdDate, '', 'DD MMM, YYYY')}
								</p>
								<p className="regular-12 gray_dark_02">
									Expired: {changeDateFormat(item?.expireDate, '', 'DD MMM, YYYY')}
								</p>
								{isAllowEdit() && (
									<div className="action-icon" onClick={() => onRemove(item?.id)}>
										<img
											src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
											alt="check"
										/>
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default OcsCertificate;
